import { CheckOutlined, CloseOutlined } from '@ant-design/icons'
import { Progress } from 'antd'
import { PASSWORD_MAX, PASSWORD_MIN } from '@User/ResetPasswordPage/constants'

import Box from '~/core/Box'
import Text from '~/core/Text'

import {
    useGetPercent,
    useGetStrengthFeedbackAndStrokeColor,
    useLoadOptions,
} from './logic'

type PasswordStrengthPropsType = {
    value?: string
}

const ICON_STYLE = { marginLeft: '4px' }

export default function PasswordStrength(props: PasswordStrengthPropsType) {
    const { value } = props
    const validValue =
        value && value.length >= PASSWORD_MIN && value.length <= PASSWORD_MAX
    const fontColor =
        value && !validValue ? 'error' : validValue ? 'success' : 'blackAlpha45'
    const icon =
        value && !validValue ? (
            <CloseOutlined style={ICON_STYLE} />
        ) : validValue ? (
            <CheckOutlined style={ICON_STYLE} />
        ) : null
    const options = useLoadOptions()
    const percent = useGetPercent({ value, options })
    const { strengthFeedback, strokeColor } =
        useGetStrengthFeedbackAndStrokeColor(percent || 0)

    return (
        <Box paddingBottom={validValue ? '0px' : '20px'} direction="col">
            <Text fontSize="11px" color={fontColor}>
                {icon} Password must be between {PASSWORD_MIN}-{PASSWORD_MAX}{' '}
                characters
            </Text>
            {validValue && (
                <Box alignItems="center">
                    <Progress
                        percent={percent}
                        size="small"
                        showInfo={false}
                        strokeColor={strokeColor}
                        style={{ maxWidth: 128, marginRight: 12 }}
                    />
                    <Text fontSize="11px" color="blackAlpha45">
                        {strengthFeedback}
                    </Text>
                </Box>
            )}
        </Box>
    )
}
